import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import ContactMessage from "../common/ContactMessage";

const PharmacyMapMessage = () => {
  let { carrier } = useParams();

  return (
    <Box sx={{p:1, pt:2, fontStyle: 'italic', m: 'auto'}}>
      { carrier === 'montana' ? (
        <>
          You may use the phone number or email address below to report inaccurate directory information.
          <br /><br />
          <a href="tel:+18069055266">806-905-5266</a>
          <br />
          <a href="mailto:providerrelations@vytlone.com">providerrelations@vytlone.com</a>
        </>
        ) : (
          <>
            <ContactMessage />
          </>
        )
      }
    </Box> 
  )
};

export default PharmacyMapMessage;